<div mat-dialog-content class="flex-col">
  @if (data.currentAttachment || tempMediaItem) {
    @if (data.currentAttachment ? data.currentAttachment : tempMediaItem; as mediaItem) {
      <div class="attachment flex-row justify-between items-center">
        <div (click)="openAttachment(mediaItem)" class="flex-row justify-start items-center">
          <mat-icon>attachment</mat-icon>&nbsp;&nbsp;
          <p class="attachment-title">{{ mediaItem.filename }}</p>
          @if (mediaItem.created_at) {
            &nbsp;
            <p class="attachment-title-created-at">({{ mediaItem.created_at | i18n_date : 'dd/MM/yyyy' | async }})</p>
          }
        </div>
        @if (tempMediaItem) {
          <div>
            <button mat-icon-button type="button" (click)="removeTempMediaItem()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
      </div>
    }
  }
  <mat-form-field appearance="outline">
    <mat-label>{{ 'program_template.attachment.name.label' | translate }}</mat-label>
    <input matInput [formControl]="attachmentDisplayName" [errorStateMatcher]="errorStateMatcher" />
    @if (attachmentDisplayName.hasError('required')) {
      <mat-error>
        {{ 'program_template.attachment.name.required' | translate }}
      </mat-error>
    }
  </mat-form-field>

  @if (!data.currentAttachment && !tempMediaItem) {
    <app-asset-upload [identifier]="purpose" [purpose]="purpose" (uploaded)="addAttachment($event)">
      <ng-template let-uploadData="uploadData">
        <app-select-media style="display: inline" [uploadData]="uploadData" [identifier]="purpose" [purpose]="purpose"> </app-select-media>
      </ng-template>
    </app-asset-upload>
  }
</div>
<div mat-dialog-actions class="flex-row justify-between items-center">
  <button mat-button (click)="closeDialog()">{{ 'generic.cancel' | translate }}</button>
  <button mat-button color="primary" (click)="saveAttachment()" [disabled]="!attachmentDisplayName.valid" cdkFocusInitial>
    {{ 'program.template.attachment_dialog.update_name.tooltip' | translate }}
  </button>
</div>
